var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mulu rmulu"},_vm._l((_vm.mulu),function(item,index){return _c('li',{key:index},[_c('p',{staticClass:"ellipsis-aRow",on:{"click":function($event){return _vm.clickmulu(item)}}},[_vm._v(" "+_vm._s(item.label)+" ")]),_c('xmlTree',{staticClass:"subitems",attrs:{"mulu":item.subitems},on:{"clickmulu":_vm.clickmulu}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }